import { __awaiter } from "tslib";
import React from 'react';
import { 
// utils
Disposable, 
// context
useXFlowApp, 
// models
MODELS, createComponentModel, 
// commands
XFlowModelCommands, } from '@antv/xflow-core';
import { NsCollapsePanelModel } from './interface';
/** 方便其他组件执行Command改变Panel内部状态 */
export const executeCollapsePanelCommand = (cmds, updateModel) => {
    cmds.executeCommand(XFlowModelCommands.UPDATE_MODEL.id, {
        getModel: (modelService) => __awaiter(void 0, void 0, void 0, function* () {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            return NsCollapsePanelModel.useModel(modelService);
        }),
        updateModel: updateModel,
    });
};
/** 方便其他组件执行Command改变Panel内部状态 */
export const useCollapsePanelData = (props) => {
    const { collapsible, nodeDataService, searchService, onCollapseChange } = props;
    const { modelService } = useXFlowApp();
    /** 创建model */
    const [state, setState, panelModel] = createComponentModel({
        /** service: onKeywordChange */
        keyword: '',
        /** 展开的key id */
        collapseData: [],
        /** 搜索结果 */
        searchResult: [],
    });
    /** 注册model成为全局状态，方便其他组件联动 */
    React.useEffect(() => {
        if (modelService.findDeferredModel(NsCollapsePanelModel.id)) {
            return;
        }
        modelService.registerModel({
            id: NsCollapsePanelModel.id,
            modelFactory: () => panelModel,
            watchChange: (self) => __awaiter(void 0, void 0, void 0, function* () {
                const graphMetaModel = yield MODELS.GRAPH_META.getModel(modelService); //useContext(MODELS.GRAPH_META.id)
                const fetch = (meta) => __awaiter(void 0, void 0, void 0, function* () {
                    const data = yield nodeDataService(meta, modelService);
                    return { collapseData: data };
                });
                const graphMetaDisposable = graphMetaModel.watch((meta) => __awaiter(void 0, void 0, void 0, function* () {
                    const { collapseData } = yield fetch(meta);
                    self.setValue(m => {
                        m.keyword = '';
                        m.collapseData = collapseData;
                        m.searchResult = [];
                    });
                }));
                return Disposable.create(() => {
                    graphMetaDisposable.dispose();
                });
            }),
        });
        /* eslint-disable-next-line  */
    }, []);
    /** 折叠文件夹 */
    const onActiveKeyChange = React.useCallback((activeKey) => {
        setState(modelState => {
            modelState.collapseData.forEach(item => {
                if (item.id === activeKey && item.collapsible !== false) {
                    item.isCollapsed = !item.isCollapsed;
                }
            });
        });
    }, [setState]);
    /** 搜索 */
    const onKeywordChange = React.useCallback((keyword, panelNodes) => __awaiter(void 0, void 0, void 0, function* () {
        if (!searchService) {
            return console.warn('searchService is not defined');
        }
        if (keyword) {
            const searchResult = yield searchService(panelNodes, keyword);
            setState(modelState => {
                modelState.keyword = keyword;
                modelState.searchResult = searchResult;
            });
        }
        else {
            setState(modelState => {
                modelState.keyword = '';
                modelState.searchResult = [];
            });
        }
    }), 
    // eslint-disable-next-line
    [searchService]);
    return {
        state,
        collapsible,
        setState,
        onKeywordChange,
        onActiveKeyChange,
        onCollapseChange,
    };
};
//# sourceMappingURL=service.js.map